import React, { ChangeEvent, useContext } from "react";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import ICatalog_Item from "../../../../../models/ICatalog_Item";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";
import SupplierContext from "../../../../../contexts/SupplierContext";
import UserContext from "../../../../../contexts/UserContext";
import * as _ from "lodash-es";
import ICatalog_ItemUI from "../../../../../models/ICatalog_ItemUI";
import UiContext from "../../../../../contexts/UiContext";
import { OwPopover } from "../../../../shared/OwPopover/OwPopover";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import OwToggle from "@components/shared/OwToggle/OwToggle";

type Props = {
    createInQbd?: boolean;
    catalogItem?: ICatalog_ItemUI;
    updateStateFn: (state: any) => void;
};

export const CatalogItemSidebarQbdSection = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const uiContext = useContext(UiContext);

    const [state, setState] = React.useState({
        create_in_qbd: props.createInQbd || false,
        has_inventory: false,
        qbd_skip_sending: props.catalogItem?.qbd_skip_sending || false,
    });

    let qbd_IncomeAccountOptions: any[] = [];

    if (supplierModel.Supplier_Integration.qbd_IncomeAccountOptions) {
        if (_.isString(supplierModel.Supplier_Integration.qbd_IncomeAccountOptions)) {
            qbd_IncomeAccountOptions = JSON.parse(supplierModel.Supplier_Integration.qbd_IncomeAccountOptions);
        }
    }

    let qbd_AssetAccountOptions: any[] = [];

    if (supplierModel.Supplier_Integration.qbd_AssetAccountOptions) {
        if (_.isString(supplierModel.Supplier_Integration.qbd_AssetAccountOptions)) {
            qbd_AssetAccountOptions = JSON.parse(supplierModel.Supplier_Integration.qbd_AssetAccountOptions);
        }
    }

    let qbd_COGSAccountOptions: any[] = [];

    if (supplierModel.Supplier_Integration.qbd_COGSAccountOptions) {
        if (_.isString(supplierModel.Supplier_Integration.qbd_COGSAccountOptions)) {
            qbd_COGSAccountOptions = JSON.parse(supplierModel.Supplier_Integration.qbd_COGSAccountOptions);
        }
    }

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const updatedState: any = {
            ...state,
            [name]: value,
        };

        props.updateStateFn(updatedState);
        setState(updatedState);
    };

    return (
        <div className={"CatalogItemSidebarQbdSection"}>
            <div className="bd-callout">
                <OwLabel title={"quickbooks_desktop"} />
            </div>
            {props.catalogItem?.guid ? (
                <div>
                    <OwLabel leftIconClass={"fad fa-info-circle"} title={"connected_to_quickbooks"} />
                    {uiContext?.showHiddenFeatures ? <div className={"text-small text-muted"}>{props.catalogItem?.qbd_ListID}</div> : null}
                    <div>
                        <OverlayTrigger
                            overlay={
                                <Tooltip>
                                    <OwLabel title={"explain_qbd_skip_sending"} />
                                </Tooltip>
                            }>
                            <i className={"fad fa-info-circle me-2"} />
                        </OverlayTrigger>
                        <OwToggle
                            label={"skip_sending"}
                            name={"qbd_skip_sending"}
                            active={state.qbd_skip_sending}
                            fn={handleChange}
                            labelOnRight={true}
                        />
                    </div>
                </div>
            ) : (
                <div>
                    <OwToggle
                        label={"create_in_quickbooks_desktop"}
                        name={"create_in_qbd"}
                        active={state.create_in_qbd}
                        fn={handleChange}
                        labelOnRight={true}
                    />
                </div>
            )}
            <div>
                {state.create_in_qbd ? (
                    <div>
                        <div>
                            <OwLabel title={"income_account"} />
                        </div>
                        <div>
                            <OwSelectOption
                                fn={handleChange}
                                valueProp={"ListID"}
                                titleProp={"Name"}
                                options={qbd_IncomeAccountOptions}
                                name={"qbd_IncomeAccountListID"}
                                selectedOption={props.catalogItem}
                                selectedOptionProp={"qbd_IncomeAccountListID"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                ) : null}

                {state.create_in_qbd && props.catalogItem?.has_inventory ? (
                    <div>
                        <div>
                            <OwLabel title={"asset_account"} />
                        </div>
                        <div>
                            <OwSelectOption
                                fn={handleChange}
                                valueProp={"ListID"}
                                titleProp={"Name"}
                                options={qbd_AssetAccountOptions}
                                name={"qbd_AssetAccountListID"}
                                selectedOption={props.catalogItem}
                                selectedOptionProp={"qbd_AssetAccountListID"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                ) : null}

                {state.create_in_qbd && props.catalogItem?.has_inventory ? (
                    <div>
                        <div>
                            <OwLabel title={"cogs_account"} />
                        </div>
                        <div>
                            <OwSelectOption
                                fn={handleChange}
                                valueProp={"ListID"}
                                titleProp={"Name"}
                                options={qbd_COGSAccountOptions}
                                name={"qbd_COGSAccountListID"}
                                selectedOption={props.catalogItem}
                                selectedOptionProp={"qbd_COGSAccountListID"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
